import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAffiliateClick, trackIntent } from '../utils/metaPixel';
interface FinalCTASectionProps {
  onOpenForm: () => void;
}
export function FinalCTASection({
  onOpenForm
}: FinalCTASectionProps) {
  return <section className="py-28 bg-gradient-to-b from-navy-900 via-[#0a2e22] to-navy-900 relative overflow-hidden" data-id="element-136">
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-emerald-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-137"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-white rounded-3xl p-10 md:p-16 text-center border-t-4 border-gold shadow-[0_20px_60px_-15px_rgba(0,0,0,0.5),0_0_40px_rgba(31,169,113,0.15)] relative overflow-hidden mx-auto max-w-3xl" data-id="element-139">
          <div className="relative z-10" data-id="element-140">
            <h2 className="text-3xl md:text-5xl font-bold font-serif text-navy mb-8 tracking-tight leading-tight" data-id="element-141">
              "The goal is not panic.
              <br data-id="element-142" />
              It is visibility."
            </h2>

            <p className="text-lg font-medium text-slate-600 mb-10 max-w-xl mx-auto leading-[1.75]" data-id="element-143">
              Understand the reporting system before paying anyone to navigate
              it. Start with the same framework used to analyze bureau
              inconsistencies across public complaint records.
            </p>

            <p className="font-serif italic text-lg text-navy max-w-2xl mx-auto mb-6 leading-[1.6]" data-id="element-144">
              Once you see how the reporting system actually works, you stop
              reacting emotionally and start moving strategically.
            </p>

            <div className="flex flex-col items-center justify-center space-y-6" data-id="element-145">
              <button onClick={() => {
              trackIntent('final_cta_playbook');
              onOpenForm();
            }} className="w-full sm:w-auto bg-emerald hover:bg-emerald-600 text-white px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 shadow-[0_8px_20px_-6px_rgba(31,169,113,0.4)] hover:shadow-[0_12px_25px_-6px_rgba(31,169,113,0.5)] transform hover:-translate-y-1 inline-flex items-center justify-center" data-id="element-146">
                Read The Playbook
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-147" />
              </button>

              <p className="text-sm text-slate-500" data-id="element-148">
                Already understand the framework? Explore monitoring
                infrastructure at{' '}
                <a href="https://procreditwatch.com/redirect.asp?guid=ZMEA756999SU" target="_blank" rel="noopener sponsored" data-product="procreditwatch" onClick={() => trackAffiliateClick('procreditwatch', 'ProCreditWatch')} className="text-emerald-700 hover:text-emerald-600 underline underline-offset-4 transition-colors font-semibold" data-id="element-149">
                  ProCreditWatch
                </a>
                .
              </p>

              <p className="text-xs text-slate-400 italic mt-4" data-id="element-150">
                Educational tools only. No guaranteed outcomes or score
                increases.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}